import api from "@/lib/api";

export async function shareTrophy(childId, lang = "en") {
  const win = window.open("about:blank", "_blank");
  const { data } = await api.post(`/children/${childId}/share`).catch((e) => { win?.close(); throw e; });
  const first = data.name.split(" ")[0];
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/share/trophy/${data.share_id}?site=${encodeURIComponent(window.location.origin)}`;
  const n = data.chapters;
  const text = lang === "fr"
    ? `🏆 Bravo ${first} ! ${n ? `${n} chapitre${n > 1 ? "s" : ""} maîtrisé${n > 1 ? "s" : ""}` : "Un chapitre terminé"} sur Anou Appran ! ${url}`
    : `🏆 Well done ${first}! ${n ? `${n} chapter${n > 1 ? "s" : ""} mastered` : "A chapter completed"} on Anou Appran! ${url}`;
  const wa = `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`;
  if (win) win.location.href = wa; else window.location.href = wa;
}
